<template>
  <svg v-if="!isFilled" width="19" height="20" viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg" class="fill-current">
    <path
      d="M0 1.748C0 1.54909 0.0790175 1.35832 0.21967 1.21767C0.360322 1.07702 0.551088 0.998001 0.75 0.998001H17.254C17.3933 0.998001 17.5298 1.03679 17.6483 1.11001C17.7668 1.18324 17.8625 1.28801 17.9248 1.41259C17.9871 1.53717 18.0135 1.67663 18.001 1.81536C17.9885 1.95408 17.9376 2.08657 17.854 2.198L13.69 7.75L17.854 13.301C17.9376 13.4124 17.9885 13.5449 18.001 13.6836C18.0135 13.8224 17.9871 13.9618 17.9248 14.0864C17.8625 14.211 17.7668 14.3158 17.6483 14.389C17.5298 14.4622 17.3933 14.501 17.254 14.501H1.5V19.251C1.49999 19.4322 1.43436 19.6073 1.31523 19.7439C1.19611 19.8805 1.03155 19.9694 0.852 19.994L0.75 20C0.568762 20 0.393658 19.9344 0.257069 19.8152C0.120481 19.6961 0.0316483 19.5316 0.00699997 19.352L0 19.25V1.748ZM15.754 2.498H1.5V13H15.754L12.152 8.2C12.0546 8.07018 12.002 7.91228 12.002 7.75C12.002 7.58772 12.0546 7.42982 12.152 7.3L15.754 2.498Z"
    />
  </svg>

  <svg v-else width="19" height="20" viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg" class="fill-current">
    <path
      d="M0 1.748C0 1.54909 0.0790175 1.35832 0.21967 1.21767C0.360322 1.07702 0.551088 0.998001 0.75 0.998001H17.254C17.3933 0.998001 17.5298 1.03679 17.6483 1.11001C17.7668 1.18324 17.8625 1.28801 17.9248 1.41259C17.9871 1.53717 18.0135 1.67663 18.001 1.81536C17.9885 1.95408 17.9376 2.08657 17.854 2.198L13.69 7.75L17.854 13.301C17.9376 13.4124 17.9885 13.5449 18.001 13.6836C18.0135 13.8224 17.9871 13.9618 17.9248 14.0864C17.8625 14.211 17.7668 14.3158 17.6483 14.389C17.5298 14.4622 17.3933 14.501 17.254 14.501H1.5V19.251C1.49999 19.4322 1.43436 19.6073 1.31523 19.7439C1.19611 19.8805 1.03155 19.9694 0.852 19.994L0.75 20C0.568762 20 0.393658 19.9344 0.257069 19.8152C0.120481 19.6961 0.0316483 19.5316 0.00699997 19.352L0 19.25V1.748Z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isFilled: {
      type: Boolean,
      default: false,
    }
  }
}
</script>
